import React, { createContext } from 'react';
import http from '../utils/httpFacade';
import axios from 'axios';

export const FarmContext = createContext();

const FarmContextProvider = ({ children }) => {
  const fetchFarm = id => {
    try {
      return http.get({ url: `crowd-farmer/farms/${id}` });
    } catch (error) {
      return error;
    }
  };

  const fetchFarms = (query = {}) => {
    try {
      return http.get({ url: 'crowd-farmer/farms', query });
    } catch (error) {
      return error;
    }
  };

  const fetchFeeds = async (id, product) => {
    try {
      return await http.get({ url: `crowd-farmer/farms/${id}/feeds/`, query: { product } });
    } catch (error) {
      return error;
    }
  };

  const fetchTask = async id => {
    try {
      return await http.get({ url: `crowd-farmer/tasks/${id}` });
    } catch (error) {
      return error;
    }
  };

  const fetchActivities = async (id, product) => {
    try {
      return await http.get({ url: `crowd-farmer/farms/${id}/activities/`, query: { product } });
    } catch (error) {
      return error;
    }
  };

  const fetchHistory = body => {
    try {
      return http.get({ url: 'crowd-farmer/history' });
    } catch (error) {
      return error;
    }
  };

  const nameYourFarm = async body => {
    try {
      return await http.patch({ url: 'crowd-farmer/farms/naming', body: JSON.stringify(body) });
    } catch (error) {
      return error;
    }
  };

  const downloadContract = async (id, token) => {
    try {
      return await axios.get(
        `${process.env.REACT_APP_PDF_GEN_APP_URL}/crowd-farmer/farms/${id}/download`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
    } catch (error) {
      return error;
    }
  };

  return (
    <FarmContext.Provider
      value={{
        fetchFarm,
        fetchFarms,
        fetchActivities,
        fetchTask,
        fetchFeeds,
        fetchHistory,
        nameYourFarm,
        downloadContract
      }}
    >
      {children}
    </FarmContext.Provider>
  );
};

export default FarmContextProvider;
